export default {
    candidate: {},
    classRoom: {},
    studentPanel: {},
    tutomat: {}
}